import { Input } from '@/components/ui/input'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
}

export function SearchInput({ value, onChange }: SearchInputProps) {
  return (
    <Input
      placeholder="Buscar por CPF, Nome ou Email..."
      value={value}
      onChange={e => onChange(e.target.value)}
      className="w-full md:w-1/3 bg-input"
    />
  )
}
